let headerGlobalsInitialized = false;
const headerState = {
	lastFocusedElm: null,
	inertElems: []
};

const setLastFocusedElm = elm => {
	headerState.lastFocusedElm = elm;
	window.lastFocusedElm = elm;
};

const clearLastFocusedElm = () => {
	headerState.lastFocusedElm = null;
	window.lastFocusedElm = null;
};

const setInertElements = inertElems => {
	headerState.inertElems = Array.from(inertElems);
	window.inertElems = headerState.inertElems;
};

const refreshInertElements = () => {
	setInertElements(document.querySelectorAll('[data-js-inert]'));
};

const getInertElements = () => {
	const connectedInertElems = headerState.inertElems.filter(elm=>elm.isConnected);
	if ( connectedInertElems.length !== headerState.inertElems.length ) {
		setInertElements(connectedInertElems);
	}
	if ( headerState.inertElems.length === 0 ) {
		refreshInertElements();
	}
	return headerState.inertElems;
};

const getOpenedSidebar = () => document.querySelector('.sidebar--opened');

const restoreLastFocusedElm = () => {
	const lastFocusedElm = headerState.lastFocusedElm || window.lastFocusedElm;
	if ( lastFocusedElm ) {
		lastFocusedElm.focus();
		clearLastFocusedElm();
	}
};

const getAriaControlledElement = elm => {
	return document.getElementById(elm.getAttribute('aria-controls'));
};

const openSidebarFromHandle = (elm, moveFocus = false) => {
	const elmSidebar = getAriaControlledElement(elm);
	if ( ! elmSidebar ) {
		return;
	}

	elm.setAttribute('aria-expanded', 'true');
	elmSidebar.show();
	if ( moveFocus ) {
		setLastFocusedElm(elm);
		elmSidebar.querySelector('[data-js-close]')?.focus();
	}
};

const hideOpenedSidebar = ({ restoreFocus = false } = {}) => {
	const openedSidebar = getOpenedSidebar();
	if ( ! openedSidebar ) {
		return false;
	}

	openedSidebar.hide();
	if ( restoreFocus ) {
		restoreLastFocusedElm();
	}
	return true;
};

const isPredictiveSearchEnabled = () => {
	const shopifyFeatures = document.getElementById('shopify-features');
	return shopifyFeatures ? JSON.parse(shopifyFeatures.text).predictiveSearch : false;
};

const ensurePredictiveSearchScript = () => {
	if ( document.body.classList.contains('predictive-script-loaded') ) {
		return;
	}

	document.body.classList.add('predictive-script-loaded');
	const predictiveSearchJS = document.createElement('script');
	predictiveSearchJS.src = KROWN.settings.predictive_search_script;
	document.head.appendChild(predictiveSearchJS);
};

const openStoreSelectorModal = elm => {
	hideOpenedSidebar();
	getAriaControlledElement(elm)?.show();
};

const syncClonedHeaderControls = root => {
	root.querySelectorAll('[id]').forEach(elm=>{
		elm.id = `${elm.id}-sticky`;
	});
	root.querySelectorAll('[aria-controls]').forEach(elm=>{
		if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
			elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
		}
	});
};

const bindClassicNavigation = root => {
	const rtl = document.documentElement.getAttribute('dir') == 'rtl';

	root.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
		elm.addEventListener('mouseover', ()=>{
			if ( elm.querySelector('.normal-menu') ) {
				elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
			}
		})
	});

	const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
		root.querySelectorAll('.style--classic li.focus').forEach(elm=>{
			if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
				elm.classList.remove('focus');
			}
		})
	}
	let babyMenuTouch = false;
	root.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
		elm.addEventListener('touchstart', ()=>{
			elm.firstElementChild.style.pointerEvents = 'none';
			elm.classList.toggle('focus');
			babyMenuTouch = true;
			closeTouchSubmenus(elm,elm.closest('.has-submenu'));
		}, { passive:true });
	})
	root.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
		if ( ! elm.classList.contains('mega-link') ) {
			elm.addEventListener('touchstart', ()=>{
				elm.firstElementChild.style.pointerEvents = 'none';
				if ( ! babyMenuTouch ) {
					elm.classList.toggle('focus');
					closeTouchSubmenus(elm);
				}
				babyMenuTouch = false;
			}, { passive:true });
		}
	})

	root.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

		const elm = childEl.parentNode;
		const elmMenu = document.getElementById(childEl.getAttribute('aria-controls'));

		elm.addEventListener('keydown', e=>{

			if ( e.keyCode == window.KEYCODES.RETURN ) {
				if ( ! e.target.classList.contains('no-focus-link') ) {
					e.preventDefault();
				}
				if ( ! elm.classList.contains('focus') ) {
					elm.classList.add('focus');
					e.target.setAttribute('aria-expanded', 'true');
					//elmMenu.setAttribute('aria-hidden', 'false');
				} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
					elm.classList.remove('focus');
					e.target.setAttribute('aria-expanded', 'false');
					//elmMenu.setAttribute('aria-hidden', 'false');
				}
			}
		});	
		
		if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
			elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', ()=>{
				if ( elm.classList.contains('focus') ) {
					elm.classList.remove('focus');
					childEl.setAttribute('aria-expanded', 'false');
					//elmMenu.setAttribute('aria-hidden', 'true');
				}
			});
		}

	});

	root.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

		const elm = childEl.parentNode;
		const elmMenu = document.getElementById(childEl.dataset.ariaControls);

		elm.addEventListener('keydown', e=>{
			if ( e.keyCode == window.KEYCODES.RETURN ) {
				if ( ! e.target.classList.contains('no-focus-link') ) {
					e.preventDefault();
				}
				if ( ! elm.classList.contains('focus') ) {
					elm.classList.add('focus');
					e.target.setAttribute('aria-expanded', 'true');
					//elmMenu.setAttribute('aria-hidden', 'false');
				} else {
					elm.classList.remove('focus');
					e.target.setAttribute('aria-expanded', 'false');
					//elmMenu.setAttribute('aria-hidden', 'true');
				}
			}
		});

		if ( elm.querySelector('.babymenu li:last-child a') ) {
			elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', ()=>{
				if ( elm.parentNode.classList.contains('focus') ) {
					elm.parentNode.classList.remove('focus');
					elm.parentNode.setAttribute('aria-expanded', 'false');
				}
			});
		}

	})
};

const initializeSubmenuMasonry = root => {
	root.querySelectorAll('.submenu-masonry').forEach(elm=>{
		if ( typeof window.Macy === 'function' ) {
			const submenuMacy = new window.Macy({
				container: elm,
				columns: elm.classList.contains('with-promotion') ? 3 : 4
			});
			setTimeout(()=>{
				submenuMacy.reInit();
			}, 100);
		}
	});
};

const syncPredictiveSearchButton = root => {
	root.querySelector('search-form [data-js-search-input] + button')?.classList.add('button--invisibile-trigger');
};

const initializeHeaderGlobals = () => {
	if ( headerGlobalsInitialized ) {
		return;
	}
	headerGlobalsInitialized = true;

	document.addEventListener('click', e=>{
		const closeButton = e.target.closest?.('sidebar-drawer [data-js-close]');
		if ( closeButton ) {
			e.preventDefault();
			const sidebar = closeButton.closest('sidebar-drawer, .sidebar');
			if ( sidebar?.classList.contains('sidebar--opened') ) {
				sidebar.hide();
			}
			return;
		}

		const sidebarHandle = e.target.closest?.('[data-js-sidebar-handle]');
		if ( sidebarHandle?.hasAttribute('aria-controls') ) {
			e.preventDefault();
			openSidebarFromHandle(sidebarHandle);
			return;
		}

		const modalTrigger = e.target.closest?.('[aria-controls="modal-store-selector"]');
		if ( modalTrigger ) {
			e.preventDefault();
			openStoreSelectorModal(modalTrigger);
			return;
		}

		if ( e.target.closest?.('.site-overlay') ) {
			hideOpenedSidebar();
		}
	});

	document.addEventListener('keyup', e=>{
		if ( e.keyCode != window.KEYCODES.RETURN ) {
			return;
		}

		const sidebarHandle = e.target.closest?.('[data-js-sidebar-handle]');
		if ( sidebarHandle?.hasAttribute('aria-controls') ) {
			openSidebarFromHandle(sidebarHandle, true);
			return;
		}

		const modalTrigger = e.target.closest?.('[aria-controls="modal-store-selector"]');
		if ( modalTrigger ) {
			openStoreSelectorModal(modalTrigger);
		}
	});

	document.addEventListener('keydown', e=>{
		if ( e.keyCode == window.KEYCODES.RETURN ) {
			const closeButton = e.target.closest?.('sidebar-drawer [data-js-close]');
			if ( closeButton ) {
				setTimeout(()=>{
					restoreLastFocusedElm();
				}, 100);
			}

			const modalTrigger = e.target.closest?.('[aria-controls="modal-store-selector"]');
			if ( modalTrigger ) {
					setLastFocusedElm(modalTrigger);
			}
		}

		if ( e.keyCode == window.KEYCODES.TAB ) {
			const searchInput = e.target.closest?.('search-form [data-js-search-input]');
			if ( searchInput ) {
				const searchResultsOverlay = document.getElementById('search-results-overlay-desktop');
				if ( searchResultsOverlay?.classList.contains('active') ) {
					searchResultsOverlay.classList.remove('active');
				}
			}
		}

		if ( e.keyCode == window.KEYCODES.ESC ) {
			hideOpenedSidebar({ restoreFocus: true });
		}
	});

	document.addEventListener('focus', e=>{
		const searchInput = e.target.closest?.('search-form [data-js-search-input]');
		if ( searchInput && isPredictiveSearchEnabled() ) {
			document.getElementById(searchInput.dataset.jsFocusOverlay)?.classList.add('active');
			ensurePredictiveSearchScript();
		}
	}, true);
};

if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){
			initializeHeaderGlobals();
			this.setupStickyHeader();
			this.setupViewportHeight();
			this.setupInertElements();
			this.setupPredictiveSearch();
			this.setupClassicNavigation();
		}

		setupStickyHeader(){
			if ( ! this.hasAttribute('data-sticky-header') ) {
				return;
			}

				let stickyHeader = null;
				const isDesktopSticky = () => window.innerWidth >= 1024;
				const getStickyHeaderMarkup = () => {
					const headerTop = `<div class="header-container header-container--top">
						<div class="header__top container--large">
							${this.querySelector('.header__top').innerHTML}
						</div>
					</div>`;
					if ( ! isDesktopSticky() ) {
						return headerTop;
					}

					return `<div class="header-container header-container--bottom portable-hide">
						<div class="header__bottom container--large">
							${this.querySelector('.header__bottom').innerHTML}
						</div>
					</div>
					${headerTop}`;
				};
				const syncStickyHeaderMarkup = () => {
					stickyHeader.innerHTML = getStickyHeaderMarkup();
					this._stickyIsDesktop = isDesktopSticky();

					syncClonedHeaderControls(stickyHeader);
					if ( ! isPredictiveSearchEnabled() ) {
						syncPredictiveSearchButton(stickyHeader);
					}
					bindClassicNavigation(stickyHeader);
					initializeSubmenuMasonry(stickyHeader);
					refreshInertElements();
				};
				const createStickyHeader = () => {
					stickyHeader = document.createElement('div');
					this._stickyHeader = stickyHeader;
					stickyHeader.className = 'sticky-header';
					stickyHeader.setAttribute('data-js-inert', '');
					document.body.append(stickyHeader);
					syncStickyHeaderMarkup();

					return stickyHeader;
				};

				this._stickyLastScrollTop = window.scrollY;
				this._stickyPinnedTop = 0;
				let stickyTicking = false;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');
				const updateStickyBounds = () => {
					this._stickyDeskBoundTop = stickyHeaderDeskBound ? stickyHeaderDeskBound.offsetTop : 0;
					this._stickyMobileBoundTop = stickyHeaderMobileBound ? stickyHeaderMobileBound.offsetTop : 0;
					if ( stickyHeader && this._stickyIsDesktop !== isDesktopSticky() ) {
						syncStickyHeaderMarkup();
					}
				};
				const hasStickyTriggerPassed = () => {
					const stickyTriggerTop = window.innerWidth >= 1024 ? this._stickyDeskBoundTop : this._stickyMobileBoundTop;
					return window.scrollY > stickyTriggerTop + 100;
				};
				updateStickyBounds();
				this.RESIZE_StickyBounds = debounce(updateStickyBounds, 150);
				window.addEventListener('resize', this.RESIZE_StickyBounds);

				this.SCROLL_StickyHelper = () =>{
					if ( stickyTicking ) return;
					stickyTicking = true;
					window.requestAnimationFrame(() => {
						const st = window.scrollY;
						const stickyTriggerPassed = hasStickyTriggerPassed();
						const currentStickyHeader = stickyHeader || ( stickyTriggerPassed ? createStickyHeader() : null );
						if ( ( st <= 0 || !stickyTriggerPassed ) && currentStickyHeader?.classList.contains('show') ) {
							currentStickyHeader.classList.remove('show');
							this._stickyLastScrollTop = st;
							stickyTicking = false;
							return;
						}

						if ( st < 0 || Math.abs(this._stickyLastScrollTop - st) <= 5 ) {
							stickyTicking = false;
							return;
						}

						if ( st > this._stickyPinnedTop ) {
							if ( st <= this._stickyLastScrollTop && currentStickyHeader && !currentStickyHeader.classList.contains('show') ) {
								this._stickyPinnedTop = currentStickyHeader.offsetTop;
								if ( stickyTriggerPassed ) {
									currentStickyHeader.classList.add('show');
								}
							} else if ( st > this._stickyLastScrollTop && currentStickyHeader?.classList.contains('show') ) {
								currentStickyHeader.classList.remove('show');
							}
						}

						this._stickyLastScrollTop = st;
						stickyTicking = false;
					});
				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
		}

		setupViewportHeight(){
			const updateWindowHeight = () => {
				document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
			};
			this.RESIZE_SidebarHelper = debounce(()=>{
				updateWindowHeight();
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			updateWindowHeight();
		}

		setupInertElements(){
			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			refreshInertElements();
		}

		setupPredictiveSearch(){
			if ( isPredictiveSearchEnabled() ) {
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				syncPredictiveSearchButton(document);
			}
		}

		setupClassicNavigation(){
			bindClassicNavigation(this);
		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			if ( this.RESIZE_StickyBounds ) {
				window.removeEventListener('resize', this.RESIZE_StickyBounds);
			}
			if ( this.SCROLL_StickyHelper ) {
				window.removeEventListener('scroll', this.SCROLL_StickyHelper);
			}
			if ( this._stickyHeader && this._stickyHeader.parentNode ) {
				this._stickyHeader.parentNode.removeChild(this._stickyHeader);
				this._stickyHeader = null;
			}
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			initializeHeaderGlobals();
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this.opened = true;
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				getInertElements().forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			getInertElements().forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach(elm=>{
				elm.setAttribute('aria-expanded', 'false');
			});

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._toggleCustomMegaMenu(e) ) {
						return;
					}
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer')?.scrollTo({top: 0});
					}
					e.target.closest('li')?.classList.add('opened');
					this._resizeContainer();
				});
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._toggleCustomMegaMenu(e) ) {
						return;
					}
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer')?.scrollTo({top: 0});
					}
					e.target.closest('li')?.classList.add('opened');
					this._resizeContainer();
				});
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer')?.scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened')?.classList.remove('opened');
					}, 301);
				});
			});

			if ( this.dataset.showHeaderActions == 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				
			}

		}

		_toggleCustomMegaMenu(e) {
			const menuItem = e.currentTarget.closest('li[data-main-menu]');
			const menuHandle = menuItem?.dataset?.mainMenu;

			if ( ! menuHandle ) {
				return false;
			}

			const matchingSubmenus = Array.from(this.querySelectorAll('[data-submenu]')).filter(submenu=>{
				return submenu.dataset.submenu === menuHandle;
			});

			if ( matchingSubmenus.length === 0 ) {
				return false;
			}

			e.preventDefault();
			e.stopPropagation();
			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;
			this.classList.remove('opened-first-submenu', 'opened-second-submenu');
			this.querySelectorAll('.opened').forEach(item=>{
				item.classList.remove('opened');
			});
			this._resizeContainer(true);

			const shouldOpen = ! menuItem.classList.contains('item-active');

			menuItem.classList.toggle('item-active', shouldOpen);
			matchingSubmenus.forEach(submenu=>{
				submenu.classList.toggle('item-active', shouldOpen);
				submenu.style.display = shouldOpen ? 'block' : '';
			});

			return true;
		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}